export const INNER_MAX_WIDTH = 141 // 1128
export const READABLE_LINE_MAX_WIDTH = 93 // 744
export const HEADER_HEIGHT_L = 16 // 128
export const HEADER_HEIGHT_S = 8 // 64
